module.exports = __webpack_public_path__ + "img/guanyu_fensi@2x.2ed171d0.png";